module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-e6c510.0d6de6af.png";